module.exports = __webpack_public_path__ + "img/home2.f0a831fe.jpg";